"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UsersError = exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _axios = _interopRequireDefault(require("axios"));

var _lodash = _interopRequireDefault(require("lodash"));

var _error = require("./error");

var _basic = _interopRequireDefault(require("./_basic"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var UsersError =
/*#__PURE__*/
function (_BasicError) {
  (0, _inherits2.default)(UsersError, _BasicError);

  /**
   * @constructor
   */
  function UsersError(error, data) {
    (0, _classCallCheck2.default)(this, UsersError);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UsersError).call(this, 'Users API Error', error, data));
  }

  return UsersError;
}(_error.BasicError);

exports.UsersError = UsersError;

var UsersApi =
/*#__PURE__*/
function (_BasicApi) {
  (0, _inherits2.default)(UsersApi, _BasicApi);

  /**
   * @constructor
   */
  function UsersApi(_ref) {
    var _this;

    var userTokenFactory = _ref.userTokenFactory,
        sdkApiUrl = _ref.sdkApiUrl,
        accountId = _ref.accountId;
    (0, _classCallCheck2.default)(this, UsersApi);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UsersApi).call(this, {
      userTokenFactory: userTokenFactory
    }));
    _this.sdkApiUrl = sdkApiUrl;
    _this.accountId = accountId;
    _this.axios = _this._createAxios();
    return _this;
  }

  (0, _createClass2.default)(UsersApi, [{
    key: "getUsers",
    value: function () {
      var _getUsers = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee() {
        var _ref2,
            projection,
            chunked,
            limit,
            last,
            _args = arguments;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _ref2 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, projection = _ref2.projection, chunked = _ref2.chunked, limit = _ref2.limit, last = _ref2.last;
                _context.next = 3;
                return this._callApi({
                  method: 'get',
                  queryParams: {
                    projection: projection,
                    chunked: chunked,
                    limit: limit,
                    last: last
                  }
                });

              case 3:
                return _context.abrupt("return", _context.sent);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getUsers() {
        return _getUsers.apply(this, arguments);
      }

      return getUsers;
    }()
  }, {
    key: "getUserById",
    value: function () {
      var _getUserById = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(userId, projection) {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._callApi({
                  method: 'get',
                  path: "/".concat(encodeURIComponent(userId)),
                  queryParams: {
                    projection: projection
                  },
                  errorData: {
                    userId: userId
                  }
                });

              case 2:
                return _context2.abrupt("return", _context2.sent);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getUserById(_x, _x2) {
        return _getUserById.apply(this, arguments);
      }

      return getUserById;
    }()
  }, {
    key: "getUserByUserName",
    value: function () {
      var _getUserByUserName = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(username) {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._callApi({
                  method: 'get',
                  path: "".concat(this.sdkApiUrl, "/users/username/").concat(encodeURIComponent(username)),
                  errorData: {
                    username: username
                  }
                });

              case 2:
                return _context3.abrupt("return", _context3.sent);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getUserByUserName(_x3) {
        return _getUserByUserName.apply(this, arguments);
      }

      return getUserByUserName;
    }()
  }, {
    key: "getUserByEmail",
    value: function () {
      var _getUserByEmail = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(email) {
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this._callApi({
                  method: 'get',
                  path: "".concat(this.sdkApiUrl, "/users/email/").concat(encodeURIComponent(email)),
                  errorData: {
                    email: email
                  }
                });

              case 2:
                return _context4.abrupt("return", _context4.sent);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getUserByEmail(_x4) {
        return _getUserByEmail.apply(this, arguments);
      }

      return getUserByEmail;
    }()
    /**
     * 
     * @param {String} user.role role of new user
     * @param {String} user.accountId accountId of new user
     * @param {String} user.email email of multi user   
     * @returns {Object} {emailSent: true/undefined, userCreated: true/undefined} userCreated - if multi user exists. if not it will send verification email and create only after comfirmation 
     */

  }, {
    key: "createUserWithMulti",
    value: function () {
      var _createUserWithMulti = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee5(user) {
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this._callApi({
                  method: 'post',
                  path: "".concat(this.sdkApiUrl, "/accounts/").concat(this.accountId, "/multi-user/create-start"),
                  payload: user
                });

              case 2:
                return _context5.abrupt("return", _context5.sent);

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function createUserWithMulti(_x5) {
        return _createUserWithMulti.apply(this, arguments);
      }

      return createUserWithMulti;
    }()
  }, {
    key: "createUser",
    value: function () {
      var _createUser = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee6(user) {
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this._callApi({
                  method: 'post',
                  payload: user
                });

              case 2:
                return _context6.abrupt("return", _context6.sent);

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function createUser(_x6) {
        return _createUser.apply(this, arguments);
      }

      return createUser;
    }()
  }, {
    key: "enableUser",
    value: function () {
      var _enableUser = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee7(user) {
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this._callApi({
                  method: 'put',
                  path: "/".concat(encodeURIComponent(user.id), "/enable"),
                  errorData: {
                    userId: user.id
                  }
                });

              case 2:
                return _context7.abrupt("return", _context7.sent);

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function enableUser(_x7) {
        return _enableUser.apply(this, arguments);
      }

      return enableUser;
    }()
  }, {
    key: "disableUser",
    value: function () {
      var _disableUser = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee8(user) {
        return _regenerator.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this._callApi({
                  method: 'put',
                  path: "/".concat(encodeURIComponent(user.id), "/disable"),
                  errorData: {
                    userId: user.id
                  }
                });

              case 2:
                return _context8.abrupt("return", _context8.sent);

              case 3:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function disableUser(_x8) {
        return _disableUser.apply(this, arguments);
      }

      return disableUser;
    }()
  }, {
    key: "deleteUser",
    value: function () {
      var _deleteUser = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee9(user) {
        return _regenerator.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this._callApi({
                  method: 'delete',
                  path: "/".concat(encodeURIComponent(user.id)),
                  errorData: {
                    userId: user.id
                  }
                });

              case 2:
                return _context9.abrupt("return", _context9.sent);

              case 3:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function deleteUser(_x9) {
        return _deleteUser.apply(this, arguments);
      }

      return deleteUser;
    }()
    /**
     * 
     * @param {String} email of multi user
     * @param {String} userId if of user to attach to multi user
     * @param {String} password SUPER_ADMIN only. when multi user not exists, it will create multi user without email verification
     * @returns {Object} {userAttached: true/undefined, emailSent: true/indefined} userAttached true - if multi user exists, if multi user not exists, it sends verification email and after verificaton user will be created
     */

  }, {
    key: "attachUser",
    value: function () {
      var _attachUser = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee10(email, userId, password) {
        return _regenerator.default.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt("return", this._callApi({
                  method: 'post',
                  path: "".concat(this.sdkApiUrl, "/accounts/").concat(this.accountId, "/multi-user/attach-start"),
                  payload: {
                    email: email,
                    userId: userId,
                    password: password
                  }
                }));

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function attachUser(_x10, _x11, _x12) {
        return _attachUser.apply(this, arguments);
      }

      return attachUser;
    }()
    /**
     * @param {String} email email of multi user
     * @returns {Object} {id, email,username} or 404
     */

  }, {
    key: "getMultiUser",
    value: function () {
      var _getMultiUser = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee11(email) {
        return _regenerator.default.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                return _context11.abrupt("return", this._callApi({
                  method: 'get',
                  path: "".concat(this.sdkApiUrl, "/multi-user/").concat(encodeURIComponent(email))
                }));

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function getMultiUser(_x13) {
        return _getMultiUser.apply(this, arguments);
      }

      return getMultiUser;
    }()
    /**
     * 
     * @param {String} param0.email email of multi user
     * @param {String} param0.password password of multi user 
     * @returns {Object} {id, email,username}
     */

  }, {
    key: "createMultiUser",
    value: function () {
      var _createMultiUser = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee12(_ref3) {
        var email, password;
        return _regenerator.default.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                email = _ref3.email, password = _ref3.password;
                return _context12.abrupt("return", this._callApi({
                  method: 'put',
                  path: "".concat(this.sdkApiUrl, "/multi-user/create"),
                  payload: {
                    email: email,
                    password: password
                  }
                }));

              case 2:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function createMultiUser(_x14) {
        return _createMultiUser.apply(this, arguments);
      }

      return createMultiUser;
    }()
  }, {
    key: "updateUser",
    value: function () {
      var _updateUser = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee13(_ref4) {
        var userId, user;
        return _regenerator.default.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                userId = _ref4.userId, user = _ref4.user;
                _context13.next = 3;
                return this._callApi({
                  method: 'put',
                  path: "/".concat(encodeURIComponent(userId)),
                  payload: _lodash.default.pick(user, ['data', 'email', 'username', 'role', 'multiUserId']),
                  errorData: {
                    userId: userId
                  }
                });

              case 3:
                return _context13.abrupt("return", _context13.sent);

              case 4:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function updateUser(_x15) {
        return _updateUser.apply(this, arguments);
      }

      return updateUser;
    }()
  }, {
    key: "setUserRole",
    value: function () {
      var _setUserRole = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee14(_ref5) {
        var userId, role;
        return _regenerator.default.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                userId = _ref5.userId, role = _ref5.role;
                _context14.next = 3;
                return this._callApi({
                  method: 'put',
                  path: "/".concat(encodeURIComponent(userId), "/role"),
                  payload: {
                    role: role
                  },
                  errorData: {
                    userId: userId,
                    role: role
                  }
                });

              case 3:
                return _context14.abrupt("return", _context14.sent);

              case 4:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function setUserRole(_x16) {
        return _setUserRole.apply(this, arguments);
      }

      return setUserRole;
    }()
  }, {
    key: "getUserData",
    value: function () {
      var _getUserData = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee15(_ref6) {
        var userId, key, keyPath, path;
        return _regenerator.default.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                userId = _ref6.userId, key = _ref6.key;
                keyPath = key ? "/".concat(encodeURIComponent(key)) : '';
                path = "/".concat(encodeURIComponent(userId), "/user-data").concat(keyPath);
                _context15.next = 5;
                return this._callApi({
                  method: 'get',
                  path: path,
                  errorData: {
                    userId: userId
                  }
                });

              case 5:
                return _context15.abrupt("return", _context15.sent);

              case 6:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function getUserData(_x17) {
        return _getUserData.apply(this, arguments);
      }

      return getUserData;
    }()
  }, {
    key: "setUserData",
    value: function () {
      var _setUserData = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee16(_ref7) {
        var userId, key, value, keyPath, path;
        return _regenerator.default.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                userId = _ref7.userId, key = _ref7.key, value = _ref7.value;
                keyPath = key ? "/".concat(encodeURIComponent(key)) : '';
                path = "/".concat(encodeURIComponent(userId), "/user-data").concat(keyPath);
                _context16.next = 5;
                return this._callApi({
                  method: 'post',
                  path: path,
                  payload: value,
                  errorData: {
                    userId: userId
                  }
                });

              case 5:
                return _context16.abrupt("return", _context16.sent);

              case 6:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function setUserData(_x18) {
        return _setUserData.apply(this, arguments);
      }

      return setUserData;
    }()
  }, {
    key: "_callApi",
    value: function () {
      var _callApi2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee17(_ref8) {
        var method, _ref8$path, path, payload, queryParams, _ref8$errorData, errorData, _ref9, headers, _ref10, responseBody;

        return _regenerator.default.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                method = _ref8.method, _ref8$path = _ref8.path, path = _ref8$path === void 0 ? '' : _ref8$path, payload = _ref8.payload, queryParams = _ref8.queryParams, _ref8$errorData = _ref8.errorData, errorData = _ref8$errorData === void 0 ? {} : _ref8$errorData;
                _context17.next = 3;
                return this.getHeaders();

              case 3:
                _ref9 = _context17.sent;
                headers = _ref9.headers;
                _context17.prev = 5;
                _context17.next = 8;
                return this.axios({
                  method: method,
                  url: path,
                  data: JSON.stringify(payload),
                  params: queryParams,
                  headers: headers
                });

              case 8:
                _ref10 = _context17.sent;
                responseBody = _ref10.data;
                return _context17.abrupt("return", responseBody);

              case 13:
                _context17.prev = 13;
                _context17.t0 = _context17["catch"](5);
                throw new UsersError(_context17.t0, _objectSpread({
                  statusCode: _lodash.default.get(_context17.t0, 'response.status')
                }, errorData, {
                  errorResponse: _lodash.default.get(_context17.t0, 'response.data')
                }));

              case 16:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this, [[5, 13]]);
      }));

      function _callApi(_x19) {
        return _callApi2.apply(this, arguments);
      }

      return _callApi;
    }()
  }, {
    key: "_createAxios",
    value: function _createAxios() {
      var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          baseUrl = _ref11.baseUrl;

      var usersUrl = "".concat(this.sdkApiUrl).concat(this.accountId ? "/accounts/".concat(encodeURIComponent(this.accountId)) : '', "/users");
      return _axios.default.create({
        baseURL: baseUrl || usersUrl // timeout : 10000

      });
    }
  }, {
    key: "getMultiUserEmails",
    value: function () {
      var _getMultiUserEmails = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee18(_ref12) {
        var emailPart, _ref13, emails;

        return _regenerator.default.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                emailPart = _ref12.emailPart;
                _context18.next = 3;
                return this._callApi({
                  path: "".concat(this.sdkApiUrl, "/multi-user/autocomplete/").concat(emailPart),
                  method: 'get'
                });

              case 3:
                _ref13 = _context18.sent;
                emails = _ref13.emails;
                return _context18.abrupt("return", emails);

              case 6:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function getMultiUserEmails(_x20) {
        return _getMultiUserEmails.apply(this, arguments);
      }

      return getMultiUserEmails;
    }()
  }, {
    key: "getMultiUserProfile",
    value: function () {
      var _getMultiUserProfile = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee19(_ref14) {
        var id;
        return _regenerator.default.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                id = _ref14.id;
                return _context19.abrupt("return", this._callApi({
                  path: "".concat(this.sdkApiUrl, "/multi-user/profile/").concat(id),
                  method: 'get'
                }));

              case 2:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function getMultiUserProfile(_x21) {
        return _getMultiUserProfile.apply(this, arguments);
      }

      return getMultiUserProfile;
    }()
  }]);
  return UsersApi;
}(_basic.default);

var _default = UsersApi;
exports.default = _default;